/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: imageload.js
 */
$.namespace("SCS.imageload");


SCS.imageload.showAjaxLoader = function() {
	var windowWidth = $(".supportcommunitysec").width();
	var barWidth = 145;
	leftVal=(windowWidth-barWidth)/2+"px";
	topVal= 70;
		
	
	$("#processingBarPanel").css('width', windowWidth).show();
	$("#processingBar").css({
		//top: topVal,
		left: leftVal
	}).show();
	};

	SCS.imageload.hideAjaxLoader = function() {
		$("#processingBarPanel").hide();
		$("#processingBar").hide();
	};


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/imageload.js
// module id = 343
// module chunks = 0